import { useHotkey } from "#app/lib/hooks/use-hotkey";
import { useGlobalSearchActions } from "./global-search-context";

/**
 * ⌘/Ctrl+K opens global search. The one owner on every viewport —
 * `GlobalSearchDialog` picks the presentation (mobile drawer, desktop command
 * dialog), so the hotkey does not branch. Trigger controls
 * (`GlobalSearchButton`, `GlobalSearchBar`) only call `openSearch`; none of
 * them register a second listener. A ⌘/Ctrl chord is never typing, so it
 * fires inside editable targets and over a modal.
 */
export function useCtrlKShortcut() {
  const { openSearch } = useGlobalSearchActions();
  useHotkey({
    key: "k",
    mod: true,
    allowInEditor: true,
    allowInModal: true,
    handler: () => openSearch("hotkey"),
  });
}
